import React from "react";
import {
  //
  List,
  Datagrid,
  ReferenceField,
  TextField,
} from "react-admin";
import ViewListIcon from "@material-ui/icons/ViewList";

export const MsgTypeIcon = ViewListIcon;

const defaultSort = { field: "name", order: "asc" };

export const MsgTypeList = props => (
  <List
    {...props}
    bulkActionButtons={false}
    perPage={25}
    sort={defaultSort}
    title="Message types"
  >
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="description" />
      <ReferenceField
        source="tenantTypeId"
        reference="lists/tenant_types"
        label="Available to"
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="id" />
    </Datagrid>
  </List>
);
